import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
export function includeKeys(object, predicate) {
  var result = {};
  if (Array.isArray(predicate)) {
    var _iterator = _createForOfIteratorHelper(predicate),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        var descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor !== null && descriptor !== void 0 && descriptor.enumerable) {
          Object.defineProperty(result, key, descriptor);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else {
    // `Reflect.ownKeys()` is required to retrieve symbol properties
    var _iterator2 = _createForOfIteratorHelper(Reflect.ownKeys(object)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _key = _step2.value;
        var _descriptor = Object.getOwnPropertyDescriptor(object, _key);
        if (_descriptor.enumerable) {
          var value = object[_key];
          if (predicate(_key, value, object)) {
            Object.defineProperty(result, _key, _descriptor);
          }
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return result;
}
export function excludeKeys(object, predicate) {
  if (Array.isArray(predicate)) {
    var set = new Set(predicate);
    return includeKeys(object, function (key) {
      return !set.has(key);
    });
  }
  return includeKeys(object, function (key, value, object) {
    return !predicate(key, value, object);
  });
}